
define('hbars!bizzabo/templates/communityEmpty', ['Handlebars'], function (Handlebars) { return Handlebars.compile('<tr class="community-people-table-person-row community-people-table-person-row-empty">\n    <td colspan="6">\n        <img src="images/community/empty/noAttendees.png?v=2">\n    </td>\n</tr>'); });

